'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _OMCheckboxDropdown = require('../../components/OMComponents/OMCheckboxDropdown/OMCheckboxDropdown');var _OMCheckboxDropdown2 = _interopRequireDefault(_OMCheckboxDropdown);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

PropertiesMultiselectWrapper = function (_Component) {_inherits(PropertiesMultiselectWrapper, _Component);function PropertiesMultiselectWrapper() {var _temp, _this, _ret;_classCallCheck(this, PropertiesMultiselectWrapper);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    handleChange = function (currVal) {var _this$props =
      _this.props,value = _this$props.value,onChange = _this$props.onChange;
      var valueNames = value.map(function (item) {return item.name;});
      var index = valueNames.indexOf(currVal);

      if (index !== -1) {
        valueNames.splice(index, 1);
      } else {
        valueNames.push(currVal);
      }
      if (valueNames.length || !(valueNames.length === _this.props.options.length - 1)) {
        onChange(valueNames);
      }
      return true;
    }, _temp), _possibleConstructorReturn(_this, _ret);}PropertiesMultiselectWrapper.prototype.

  render = function render() {
    var checkboxOptions = this.props.value.map(function (item) {return item.name;});
    return (
      _react2.default.createElement(_OMCheckboxDropdown2.default, {
        options: this.props.options || [],
        title: this.props.title,
        onChange: this.handleChange,
        value: checkboxOptions || {},
        items: this.props.value,
        className: this.props.multiSelectClassName,
        onOpen: this.props.onOpen,
        width: this.props.width,
        counterSelected: this.props.counterSelected,
        counterGeneral: this.props.counterGeneral }));


  };return PropertiesMultiselectWrapper;}(_react.Component);exports.default = PropertiesMultiselectWrapper;


PropertiesMultiselectWrapper.propTypes = {
  options: _propTypes2.default.array,
  title: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([
  _propTypes2.default.string,
  _propTypes2.default.array]),

  onChange: _propTypes2.default.func,
  onOpen: _propTypes2.default.func,
  multiSelectClassName: _propTypes2.default.string,
  width: _propTypes2.default.number,
  counterSelected: _propTypes2.default.number,
  counterGeneral: _propTypes2.default.number };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PropertiesMultiSelectWrapper/PropertiesMultiSelectWrapper.js
// module id = 3011
// module chunks = 0